import { FC, memo, ReactNode, useState } from 'react';
import { Button, Form, Typography } from 'antd';
import cn from 'classnames';

import { FieldData, ModalProps } from 'models';

import { ModalComponent } from 'componets/common';
import { SubmitButton } from 'componets/form';

import { useAppSelector } from 'hooks';
import i18n from 'utils/i18n';

import s from './index.module.scss';

const { t } = i18n;

interface ConfirmationModalProps extends ModalProps {
	onAgree: () => void;
	title: string;
	text: string | ReactNode;
	info?: string | ReactNode;
	submitText?: string;
	cancelText?: string;
	loading: boolean;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = memo(
	({
		isOpen,
		onClose,
		onAgree,
		title,
		info,
		loading,
		text,
		submitText = t('yesText'),
		cancelText = t('noText'),
	}) => {
		const [form] = Form.useForm();
		const [fields, setFields] = useState<FieldData[]>([]);

		const isAdmin = useAppSelector((state) => state.cookies.isAdmin);

		const onFinish = () => {
			onAgree();
		};

		return (
			<ModalComponent isOpen={isOpen} onClose={onClose} title={title}>
				<Form onFinish={onFinish} onFieldsChange={setFields} fields={fields} form={form}>
					<div className="modal-content">
						{info}
						<Typography.Text className="modal-text">{text}</Typography.Text>
						<div className="modal-footer">
							<SubmitButton
								text={submitText}
								className={cn({ 'ant-btn-grey': isAdmin })}
								classNameWrapper={s.submitWrapper}
								loading={loading}
							/>

							<Button onClick={onClose}>{cancelText}</Button>
						</div>
					</div>
				</Form>
			</ModalComponent>
		);
	},
);
